var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from '@tanstack/react-query';
export var fetchMultiTokens = function (tokens, minMarketCap, id) { return __awaiter(void 0, void 0, void 0, function () {
    var networks, url, response, payload, data, results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                networks = [1, 137, 10, 56, 43114, 42161, 250, 8453, 81457, 1399811149];
                url = '/api/explore/multiTokenData';
                return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        body: JSON.stringify({ networks: networks, tokens: tokens }),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                payload = _a.sent();
                data = payload === null || payload === void 0 ? void 0 : payload.data;
                results = data.data.filterTokens.results;
                results = results
                    .filter(function (x) {
                    return parseFloat(x.marketCap) >= minMarketCap;
                })
                    .sort(function (a, b) {
                    var _a, _b, _c, _d;
                    if (((_a = a === null || a === void 0 ? void 0 : a.token) === null || _a === void 0 ? void 0 : _a.networkId) === 1 && ((_b = b === null || b === void 0 ? void 0 : b.token) === null || _b === void 0 ? void 0 : _b.networkId) !== 1) {
                        return 1;
                    }
                    if (((_c = a === null || a === void 0 ? void 0 : a.token) === null || _c === void 0 ? void 0 : _c.networkId) !== 1 && ((_d = b === null || b === void 0 ? void 0 : b.token) === null || _d === void 0 ? void 0 : _d.networkId) === 1) {
                        return -1;
                    }
                    var marketCapDiff = b.marketCap - a.marketCap;
                    if (marketCapDiff > 0) {
                        return 2;
                    }
                    else if (marketCapDiff < 0) {
                        return -2;
                    }
                    return 0;
                });
                // await Promise.all(
                //   results.map(async (item, idx) => {
                //     const _tokenData = await getBasicTokenInfo(item.token.networkId, item.token.address, true);
                //     results[idx] = {
                //       ...item,
                //       token: {
                //         ...item.token,
                //         tokenInfo: _tokenData.tokenInfo,
                //         tokenStats: _tokenData.tokenStats,
                //       },
                //     };
                //   })
                // );
                // results.forEach(async (item, idx) => {
                //   const _tokenData = await getBasicTokenInfo(item.token.networkId, item.token.address, true);
                //   results[idx] = {
                //     ...item,
                //     token: {
                //       ...item.token,
                //       tokenInfo: _tokenData.tokenInfo,
                //       tokenStats: _tokenData.tokenStats,
                //     },
                //   };
                // });
                return [2 /*return*/, results];
        }
    });
}); };
export default function useMultiTokenData(_a) {
    var _this = this;
    var tokens = _a.tokens, _b = _a.minMarketCap, minMarketCap = _b === void 0 ? 1000000 : _b, id = _a.id, _c = _a.staleTime, staleTime = _c === void 0 ? 1000 * 60 * 30 : _c;
    var query = useQuery({
        queryKey: ['multiTokenData', tokens, minMarketCap],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var tokenArray, data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tokenArray = tokens.reduce(function (acc, curr, i) {
                            if (i % 80 === 0) {
                                acc.push([]);
                            }
                            acc[acc.length - 1].push(curr);
                            return acc;
                        }, []);
                        return [4 /*yield*/, Promise.all((tokenArray || [tokens]).map(function (tokenArray) {
                                return fetchMultiTokens(tokenArray, minMarketCap, id);
                            }))];
                    case 1:
                        data = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.flat();
                        return [2 /*return*/, data];
                }
            });
        }); },
        staleTime: staleTime,
    });
    return query;
}
